export default{container:"w_F4",right:"w_F5",left:"w_F6",panel:"w_F7",small:"w_F8",medium:"w_F9",large:"w_GA",header:"w_GB",title:"w_GC",content:"w_GD",contentInner:"w_GE",actions:"w_GF"};
